export default {
  title: 'Fremhævede produkter',
};
